<template>
  <div class="event-list">
    <transition name="el-zoom-in-center">
      <div v-show="showListBox" :class="[evenRightClass]">
        <!-- 备用，重新接入数据写逻辑时用 -->
        <!-- <div>
                <div style="display: flex;">
                    <div style="width:50%;padding-left: 10px;">
                        当天未处理:12
                        <el-button size="mini" style="margin-left:6px ;" type="primary">查看</el-button>
                    </div>
                    <div style="width:50%;padding-left: 10px;">
                        当月未处理:12
                        <el-button size="mini" style="margin-left:6px ;" type="primary">查看</el-button>
                    </div>
                </div>
                <div style="display: flex;background-color: rgba(0,183,283,0.4);height: 42px;margin-top: 20px;line-height: 42px;text-align: center;">
                    <div style="width: 33.3%;">
                        <span style="padding-right: 10px;">养护部门</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                    <div style="width: 33.3%;">
                        <span style="padding-right: 10px;">全部</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                    <div style="width: 33.3%;">
                        <span style="padding-right: 10px;">筛选</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                </div>
                <div style="padding:20px 10px;height: 374px;overflow: auto;">
                    <div v-for="(item, key) in eventList" :key="key">
                        <div style="display: flex;">
                            <div style="width: 60px;"><i :class="item.iconClass"></i></div>
                            <div style="width:190px;">
                                <p>{{ item.time }}</p>
                                <p style="line-height: 36px;">
                                    <span>{{ item.stakeNumber }}</span>
                                    <span>{{ item.direction }}</span>
                                </p>
                            </div>
                            <div style="width: 70px;margin-top: 10px;">
                                <el-button type="primary" size="mini" round>{{ item.grade }}</el-button>
                            </div>
                            <div style="text-align: center;">
                                <p>处理中</p>
                                <p style="padding-top: 10px;"><i class="el-icon-arrow-down"></i></p>
                            </div>
                        </div>
                        <div style="border: 1px #414445 dashed;margin: 8px 0;opacity: 0.8;"></div>
                    </div>
                </div>
            </div> -->
        <!-- 嵌入小程序编译H5的iframe更快，省写二次逻辑和 测试少测试PC -->
        <iframe
          ref="h5Iframe"
          :src="h5IframeEventSrc"
          frameborder="0"
          style="height: 100%; width: 100%"
        ></iframe>
      </div>
    </transition>
    <div
      v-show="videoBox.show"
      class="u-position-absolute u-r-20 u-b-10 u-z-index-100"
      style="width: 20px; height: 20px"
    >
      <video
        ref="dvBox"
        :src="videoBox.src"
        width="100%"
        controls
        muted
        autoplay
      ></video>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  computed: {
    ...mapState({
      eventList: (state) => state.eventListBox.eventList
    })
  },
  data() {
    const webServerHost = window.location.origin;
    return {
      showListBox: true,
      // h5IframeEventSrc: 'http://localhost:8080/', //hbx 运行时调试地址
      h5IframeEventSrc: webServerHost + '/h5/', //正式打包地址
      videoBox: {},
      evenRightClass: 'evenRightClass'
    };
  },
  methods: {
    ...mapMutations(['set_busunessMapMaskRoundLngLat']),
    closeDv() {
      function checkFull() {
        var isFull =
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen;
        if (isFull === undefined) isFull = false;
        return isFull;
      }
      if (!checkFull()) {
        //退出全屏
        this.$refs.dvBox.pause();
      }
    },
    sendMessage() {
      if (this.evenRightClass === 'evenRightClass')
        this.$refs.h5Iframe.contentWindow.postMessage(
          { refresh: new Date().getTime() },
          '*'
        );
      //参数二是Iframe子目标限制,只有域名http://localhost:8080的那个窗口才能收到消息，'*'则无限制
    },
    getMessage({ data }) {
      if (data.img) {
        this.$store.commit('set_dbClickImg', data.img);
      } else if (data.videoSrc) {
        this.videoBox.src = data.videoSrc;
        this.videoBox.show = true;
        this.videoBox = Object.assign({}, this.videoBox);
        const element = this.$refs.dvBox;
        if (element.requestFullScreen) {
          element.requestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        }
      } else {
        console.log(data.view);
        this.showListBox = false;
        setTimeout(() => {
          if (data.view === 'view-lg') {
            this.set_busunessMapMaskRoundLngLat(data.mark);
            this.evenRightClass = 'even-list-lg';
          } else {
            this.evenRightClass = 'evenRightClass';
            if (data.view === 'view-md-refresh') this.sendMessage();
          }
          this.showListBox = true;
        }, 500);
      }
    }
  },
  created() {
    /* 接收ifhrame传来点击列表跳转详情链接。 嵌入小程序编译H5的iframe更快，省写二次逻辑和 测试少测试PC*/
    window.addEventListener('message', this.getMessage, false);
    /*下面监听退出全屏*/
    window.addEventListener('resize', this.closeDv);
  },
  destroyed() {
    window.removeEventListener('resize', this.closeDv); //销毁页面一定要销毁window全局监听
    window.removeEventListener('message', this.getMessage);
  }
};
</script>

<style lang="scss">
.event-list {
  .default-style {
    position: absolute;
    right: 18px;
    bottom: 5px;
    z-index: 400;
    background-size: 100% 100%;
    background-color: rgba(0, 0, 0, 0.8);
  }
  .evenRightClass {
    @extend .default-style;
    width: 430px;
    height: 550px;
    padding: 26px 20px 16px 22px;
    .el-button--mini,
    .el-button--mini.is-round {
      padding: 5px 10px;
    }
  }
  .even-list-lg {
    @extend .default-style;
    width: 430px;
    height: 840px;
    padding: 32px 20px 22px 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event-warn/event-list.vue